import {
  FIXED_TABLE_PAGE_BACKGROUND,
  isValidThemeColor,
  THEME_PRESETS,
} from './themePresets.mjs';

export const CURRENT_PREFERENCE_VERSION = 2;
export const DEFAULT_LOCALE = 'zh-CN';
export const SUPPORTED_LOCALES = ['zh-CN', 'zh-HK'];

export const DEFAULT_THEME_CONFIG = THEME_PRESETS[0].themeConfig;

export function buildPreferenceStorageKey(userId) {
  return `zcmis:user-preference:${userId || 'anonymous'}`;
}

export function mergeThemeConfig(themeConfig = {}) {
  const merged = {
    ...DEFAULT_THEME_CONFIG,
    ...themeConfig,
    tableTheme: {
      ...DEFAULT_THEME_CONFIG.tableTheme,
      ...(themeConfig.tableTheme || {}),
    },
  };
  ['themeColor', 'buttonColor', 'formLabelColor'].forEach((key) => {
    if (!isValidThemeColor(merged[key])) merged[key] = DEFAULT_THEME_CONFIG[key];
  });
  Object.keys(DEFAULT_THEME_CONFIG.tableTheme).forEach((key) => {
    if (!isValidThemeColor(merged.tableTheme[key])) {
      merged.tableTheme[key] = DEFAULT_THEME_CONFIG.tableTheme[key];
    }
  });
  merged.tableTheme.pageBackground = FIXED_TABLE_PAGE_BACKGROUND;
  return merged;
}

export function normalizePreference(preference = {}) {
  const isCurrentVersion = Number(preference.version) === CURRENT_PREFERENCE_VERSION;
  return {
    version: CURRENT_PREFERENCE_VERSION,
    locale: SUPPORTED_LOCALES.includes(preference.locale) ? preference.locale : DEFAULT_LOCALE,
    themeConfig: mergeThemeConfig(isCurrentVersion ? preference.themeConfig : DEFAULT_THEME_CONFIG),
  };
}

export function loadLocalPreference(userId, storage = window.localStorage) {
  try {
    const raw = storage.getItem(buildPreferenceStorageKey(userId));
    if (!raw) return normalizePreference({ version: CURRENT_PREFERENCE_VERSION });
    const storedPreference = JSON.parse(raw);
    const normalized = normalizePreference(storedPreference);
    const normalizedValue = JSON.stringify(normalized);
    if (JSON.stringify(storedPreference) !== normalizedValue) {
      try {
        storage.setItem(buildPreferenceStorageKey(userId), normalizedValue);
      } catch (error) {
        // A readable preference remains usable even when storage is temporarily read-only.
      }
    }
    return normalized;
  } catch (error) {
    return normalizePreference({ version: CURRENT_PREFERENCE_VERSION });
  }
}

export function saveLocalPreference(userId, preference, storage = window.localStorage) {
  const normalized = normalizePreference({ ...preference, version: CURRENT_PREFERENCE_VERSION });
  storage.setItem(buildPreferenceStorageKey(userId), JSON.stringify(normalized));
  return normalized;
}
